import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/packages/web/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfflineDetector"] */ "/vercel/path0/packages/web/components/OfflineDetector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToasterProvider"] */ "/vercel/path0/packages/web/components/ui/toaster.tsx");
